module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('g', [_c('axisright', {
    staticClass: "axis",
    attrs: {
      "scale": _vm.scaleY,
      "width": _vm.width,
      "height": _vm.height,
      "margin": _vm.margin,
      "unit": "sol/s"
    }
  }), _vm._v(" "), _c('axisbottom', {
    staticClass: "axis axisx",
    attrs: {
      "scale": _vm.scaleX,
      "width": _vm.width,
      "height": _vm.height,
      "margin": _vm.margin
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": _vm.linePath
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5e86b60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Linechart.vue
// module id = 795
// module chunks = 1